"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable: variable-name no-shadowed-variable max-line-length */
exports.Rbar95 = 8.314371; // [kJ/(kmol K)]
exports.R95 = 0.46151805; // [kJ/(kg K)]
exports.M95 = 18.015268; // [kg/kmol]
exports.rho_c = 322; // [kg/m3]
exports.T_c = 647.096; // [K]
exports.p_c = 22.064; // [MPa];
var n = [
    NaN,
    0.125335479355233e-1, 0.78957634722828e1, -0.87803203303561e1, 0.31802509345418, -0.26145533859358,
    -0.78199751687981e-2, 0.88089493102134e-2, -0.66856572307965, 0.20433810950965, -0.66212605039687e-4,
    -0.19232721156002, -0.25709043003438, 0.16074868486251, -0.40092828925807e-1, 0.39343422603254e-6,
    -0.75941377088144e-5, 0.56250979351888e-3, -0.15608652257135e-4, 0.11537996422951e-8,
    0.36582165144204e-6, -0.13251180074668e-11, -0.62639586912454e-9, -0.10793600908932,
    0.17611491008752e-1, 0.22132295167546, -0.40247669763528, 0.58083399985759, 0.49969146990806e-2,
    -0.31358700712549e-1, -0.74315929710341, 0.47807329915480, 0.20527940895948e-1,
    -0.13636435110343, 0.14180634400617e-1, 0.83326504880713e-2, -0.29052336009585e-1,
    0.38615085574206e-1, -0.20393486513704e-1, -0.16554050063734e-2, 0.19955571979541e-2,
    0.15870308324157e-3, -0.16388568342530e-4, 0.43613615723811e-1, 0.34994005463765e-1,
    -0.76788197844621e-1, 0.22446277332006e-1, -0.62689710414685e-4, -0.55711118565645e-9,
    -0.19905718354408, 0.31777497330738, -0.11841182425981, -0.31306260323435e2, 0.31546140237781e2,
    -0.25213154341695e4, -0.14874640856724, 0.31806110878444,
];
var d = [
    Number.MIN_VALUE,
    1, 1, 1, 2, 2, 3, 4, 1, 1, 1, 2, 2, 3, 4, 4, 5, 7, 9, 10, 11, 13, 15, 1, 2, 2, 2, 3, 4, 4, 4, 5, 6,
    6, 7, 9, 9, 9, 9, 9, 10, 10, 12, 3, 4, 4, 5, 14, 3, 6, 6, 6, 3, 3, 3,
];
var t = [
    NaN,
    -0.5, 0.875, 1, 0.5, 0.75, 0.375, 1, 4, 6, 12, 1, 5, 4, 2, 13, 9, 3, 4, 11, 4, 13, 1, 7, 1, 9, 10, 10, 3,
    7, 10, 10, 6, 10, 10, 1, 2, 3, 4, 8, 6, 9, 8, 16, 22, 23, 23, 10, 50, 44, 46, 50, 0, 1, 4,
];
var c = [
    Number.MIN_VALUE,
    0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
    2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 4, 6, 6, 6, 6, 0, 0, 0,
];
var alpha = [
    NaN,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    20,
    20,
    20,
];
var beta = [
    NaN,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    150,
    150,
    250,
    0.3,
    0.3,
];
var gamma = [
    NaN,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    1.21,
    1.21,
    1.25,
];
var epsilon = [
    NaN,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    1,
    1,
    1,
];
var a = [
    NaN,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    3.5,
    3.5,
];
var b = [
    NaN,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0.85,
    0.95,
];
var A = [
    NaN,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0.32,
    0.32,
];
var B = [
    NaN, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0.2,
    0.2,
];
var C = [
    NaN, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    28,
    32,
];
var D = [
    NaN,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    700.0,
    800.0,
];
///// <param name="p">Pressure [Pa]</param>
///// <param name="T">Temperature [K] </param>
///// <returns>[kJ/kg]</returns>
//public static double Get_Specific_Enthalpy_of_Liquid_Water(double p, double T)
//{
//  double v_w = IAPWS_IF97.Get_Specific_Volume_of_Liquid_Water(p, T);
//  double tau = T_c / T;
//  double delta = 1 / (v_w * rho_c);
//  double dalphao_dtau_delta = Get_dalphao_dtau_delta(tau);
//  double dalphar_dtau_delta = Get_dalphar_dtau_delta(delta, tau);
//  double dalphar_ddelta_tau = Get_dalphar_ddelta_tau(delta, tau);
//  double h_w = R95 * T * (1 + tau * (dalphao_dtau_delta + dalphar_dtau_delta) + delta * dalphar_ddelta_tau);
//  return h_w;
//}
function Get_Ideal_Gas_Molar_Enthalpy_of_Water_Vapor_95(T) {
    // At temperatures T ≤ 273.15K use [1] eq. (3.48) and table 2.6
    var tau = exports.T_c / T;
    var hbar0_95 = -0.01102303806; // [kJ/kmol]
    var dalphao_dtau_delta = Get_dalphao_dtau_delta(tau);
    var hbaro_w = hbar0_95 + exports.Rbar95 * T * (1 + tau * dalphao_dtau_delta);
    return hbaro_w;
}
exports.Get_Ideal_Gas_Molar_Enthalpy_of_Water_Vapor_95 = Get_Ideal_Gas_Molar_Enthalpy_of_Water_Vapor_95;
function Get_dalphao_dtau_delta(tau) {
    var no = [NaN, -8.3204464837497, 6.6832105275932, 3.00632, 0.012436, 0.97315, 1.27950, 0.96956, 0.24873];
    var gammao = [NaN, 0, 0, 0, 1.28728967, 3.53734222, 7.74073708, 9.24437796, 27.5075105];
    var sum = 0;
    for (var i = 4; i <= 8; i++) {
        sum += no[i] * gammao[i] * Math.pow((Math.exp(gammao[i] * tau) - 1), -1);
    }
    var dalphao_dtau_delta = no[2] + no[3] * Math.pow(tau, -1) + sum;
    return dalphao_dtau_delta;
}
exports.Get_dalphao_dtau_delta = Get_dalphao_dtau_delta;
function Get_dalphar_ddelta_tau(delta, tau) {
    var dalphar_ddelta = 0;
    for (var i = 1; i <= 7; i++) {
        dalphar_ddelta += n[i] * d[i] * Math.pow(delta, (d[i] - 1.0)) * Math.pow(tau, t[i]);
    }
    for (var i = 8; i <= 51; i++) {
        dalphar_ddelta += n[i] * Math.exp(-Math.pow(delta, c[i])) *
            (Math.pow(delta, (d[i] - 1.0)) * Math.pow(tau, t[i]) * (d[i] - c[i] * Math.pow(delta, c[i])));
    }
    for (var i = 52; i <= 54; i++) {
        dalphar_ddelta += n[i] * Math.pow(delta, d[i]) * Math.pow(tau, t[i])
            *
                Math.exp(-alpha[i] * Math.pow((delta - epsilon[i]), 2) - beta[i] * Math.pow((tau - gamma[i]), 2)) *
            (d[i] / delta - 2.0 * alpha[i] * (delta - epsilon[i]));
    }
    for (var i = 55; i <= 56; i++) {
        var psi_i = Math.exp(-C[i] * Math.pow(delta - 1.0, 2) - D[i] * Math.pow(tau - 1.0, 2));
        var theta_i = (1.0 - tau) + A[i] * Math.pow(Math.pow(delta - 1.0, 2), 1.0 / (2.0 * beta[i]));
        var DELTA_i = Math.pow(theta_i, 2) + B[i] * Math.pow(Math.pow(delta - 1.0, 2), a[i]);
        var dpsii_ddelta = Get_dpsii_ddelta(psi_i, delta, i);
        var dDELTA_i_dDelta = Get_dDELTAi_ddelta(delta, theta_i, i);
        var dDELTAibi_ddelta = Get_dDELTAibi_ddelta(dDELTA_i_dDelta, DELTA_i, i);
        dalphar_ddelta += n[i] * (Math.pow(DELTA_i, b[i]) * (psi_i + delta * dpsii_ddelta) + (dDELTAibi_ddelta) * delta * psi_i);
    }
    return dalphar_ddelta;
}
exports.Get_dalphar_ddelta_tau = Get_dalphar_ddelta_tau;
function Get_d2alphar_ddelta2(delta, tau) {
    var d2Alphar_dDelta2 = 0;
    for (var i = 1; i <= 7; i++) {
        d2Alphar_dDelta2 += n[i] * d[i] * (d[i] - 1.0) * Math.pow(delta, d[i] - 2.0) * Math.pow(tau, t[i]);
    }
    for (var i = 8; i <= 51; i++) {
        d2Alphar_dDelta2 += n[i] * Math.exp(-Math.pow(delta, c[i])) *
            (Math.pow(delta, d[i] - 2.0) * Math.pow(tau, t[i]) *
                ((d[i] - c[i] * Math.pow(delta, c[i])) * (d[i] - 1.0 - c[i] * Math.pow(delta, c[i])) -
                    Math.pow(c[i], 2) * Math.pow(delta, c[i])));
    }
    for (var i = 52; i <= 54; i++) {
        d2Alphar_dDelta2 += n[i] * Math.pow(tau, t[i]) *
            Math.exp(-alpha[i] * Math.pow((delta - epsilon[i]), 2) - beta[i] * Math.pow(tau - gamma[i], 2)) *
            (-2 * alpha[i] * Math.pow(delta, d[i]) +
                4.0 * Math.pow(alpha[i], 2) * Math.pow(delta, d[i]) * Math.pow(delta - epsilon[i], 2) -
                4.0 * d[i] * alpha[i] * Math.pow(delta, (d[i] - 1.0)) * (delta - epsilon[i]) +
                d[i] * (d[i] - 1.0) * Math.pow(delta, (d[i] - 2.0)));
    }
    for (var i = 55; i <= 56; i++) {
        var psi_i = Math.exp(-C[i] * Math.pow(delta - 1, 2) - D[i] * Math.pow(tau - 1, 2));
        var theta_i = (1.0 - tau) + A[i] * Math.pow(Math.pow(delta - 1.0, 2), 1.0 / (2.0 * beta[i]));
        var DELTA_i = Math.pow(theta_i, 2) + B[i] * Math.pow(Math.pow(delta - 1.0, 2), a[i]);
        var dpsii_ddelta = Get_dpsii_ddelta(psi_i, delta, i);
        var d2psii_ddelta2 = Get_d2psii_ddelta2(psi_i, delta, i); //d3alphar = 0
        var dDELTAi_ddelta = Get_dDELTAi_ddelta(delta, theta_i, i);
        var d2DELTAi_ddelta2 = Get_d2DELTAi_ddelta2(theta_i, delta, dDELTAi_ddelta, i); // d3alphar
        var dDELTAibi_ddelta = Get_dDELTAibi_ddelta(dDELTAi_ddelta, DELTA_i, i);
        var d2DELTAibi_ddelta2 = Get_d2DELTAibi_ddelta2(d2DELTAi_ddelta2, dDELTAi_ddelta, DELTA_i, i); // d3alphar
        d2Alphar_dDelta2 += n[i] *
            (Math.pow(DELTA_i, b[i]) * (2.0 * dpsii_ddelta + delta * d2psii_ddelta2) +
                2 * dDELTAibi_ddelta * (psi_i + dpsii_ddelta) + d2DELTAibi_ddelta2 * delta * psi_i);
    }
    return d2Alphar_dDelta2;
}
exports.Get_d2alphar_ddelta2 = Get_d2alphar_ddelta2;
function Get_d2alphar_ddelta_dtau(delta, tau) {
    //[1] eq. (2.37) and table 2.8:
    var d2alphar_ddelta_dtau = 0;
    for (var i = 1; i <= 7; i++) {
        d2alphar_ddelta_dtau += n[i] * d[i] * t[i] * Math.pow(delta, d[i] - 1) * Math.pow(tau, t[i] - 1);
    }
    for (var i = 8; i <= 51; i++) {
        d2alphar_ddelta_dtau += n[i] * t[i] * Math.pow(delta, d[i] - 1) * Math.pow(tau, t[i] - 1) * (d[i] - c[i] * Math.pow(delta, c[i])) * Math.exp(-Math.pow(delta, c[i]));
    }
    for (var i = 52; i <= 54; i++) {
        d2alphar_ddelta_dtau += (n[i] * Math.pow(delta, d[i]) * Math.pow(tau, t[i]) * Math.exp(-alpha[i] * Math.pow(delta - epsilon[i], 2) - beta[i] * Math.pow(tau - gamma[i], 2)) * (d[i] / delta - 2 * alpha[i] * (delta - epsilon[i])) * (t[i] / tau - 2 * beta[i] * (tau - gamma[i])));
    }
    for (var i = 55; i <= 56; i++) {
        var psi_i = Math.exp(-C[i] * Math.pow(delta - 1, 2) - D[i] * Math.pow(tau - 1, 2));
        var theta_i = (1 - tau) + A[i] * Math.pow((Math.pow((delta - 1), 2)), (1 / (2 * beta[i])));
        var DELTA_i = Math.pow(theta_i, 2) + B[i] * Math.pow((Math.pow((delta - 1), 2)), a[i]);
        var dpsii_ddelta = Get_dpsii_ddelta(psi_i, delta, i);
        var dDELTAi_ddelta = Get_dDELTAi_ddelta(delta, theta_i, i);
        var dDELTAibi_ddelta = Get_dDELTAibi_ddelta(dDELTAi_ddelta, DELTA_i, i);
        var dpsii_dtau = Get_dpsii_dtau(tau, psi_i, i);
        var d2psii_ddelta_dtau = Get_d2psii_ddelta_dtau(delta, tau, psi_i, i);
        var dDELTAibi_dtau = Get_dDELTAibi_dtau(DELTA_i, theta_i, i);
        var d2DELTAibi_ddelta_dtau = Get_d2DELTAibi_ddelta_dtau(delta, dDELTAi_ddelta, DELTA_i, theta_i, i);
        d2alphar_ddelta_dtau += n[i] * (Math.pow(DELTA_i, b[i]) * ((dpsii_dtau) + delta * (d2psii_ddelta_dtau))
            + delta * (dDELTAibi_ddelta) * (dpsii_dtau) + (dDELTAibi_dtau) * (psi_i + delta * (dpsii_ddelta))
            + (d2DELTAibi_ddelta_dtau) * delta * psi_i);
    }
    return d2alphar_ddelta_dtau;
}
exports.Get_d2alphar_ddelta_dtau = Get_d2alphar_ddelta_dtau;
function Get_d3alphar_ddelta2_dtau(delta, tau) {
    var d3alphar_ddelta2_dtau = 0;
    for (var i = 1; i <= 7; i++) {
        d3alphar_ddelta2_dtau += n[i] * d[i] * t[i] * (d[i] - 1) * Math.pow(delta, d[i] - 2) * Math.pow(tau, t[i] - 1);
    }
    for (var i = 8; i <= 51; i++) {
        d3alphar_ddelta2_dtau += n[i] * t[i] * Math.exp(-Math.pow(delta, c[i])) * Math.pow(delta, d[i] - 2) * Math.pow(tau, t[i] - 1) * ((d[i] - c[i] * Math.pow(delta, c[i])) * (d[i] - 1 - c[i] * Math.pow(delta, c[i])) - Math.pow(c[i], 2) * Math.pow(delta, c[i]));
    }
    for (var i = 52; i <= 54; i++) {
        d3alphar_ddelta2_dtau += n[i] * Math.pow(tau, t[i]) * Math.exp(-alpha[i] * Math.pow(delta - epsilon[i], 2) - beta[i] * Math.pow(tau - gamma[i], 2)) * (t[i] / tau - 2 * beta[i] * (tau - gamma[i])) * (-2 * alpha[i] * Math.pow(delta, d[i]) + 4 * Math.pow(alpha[i], 2) * Math.pow(delta, d[i]) * Math.pow(delta - epsilon[i], 2) - 4 * d[i] * alpha[i] * Math.pow(delta, d[i] - 1) * (delta - epsilon[i]) + d[i] * (d[i] - 1) * Math.pow(delta, d[i] - 2));
    }
    for (var i = 55; i <= 56; i++) {
        var psi_i = Math.exp(-C[i] * Math.pow(delta - 1, 2) - D[i] * Math.pow(tau - 1, 2));
        var theta_i = (1 - tau) + A[i] * Math.pow((Math.pow((delta - 1), 2)), (1 / (2 * beta[i])));
        var DELTA_i = Math.pow(theta_i, 2) + B[i] * Math.pow((Math.pow((delta - 1), 2)), a[i]);
        var dpsii_dtau = Get_dpsii_dtau(tau, psi_i, i);
        var dpsii_ddelta = Get_dpsii_ddelta(psi_i, delta, i);
        var d2psii_ddelta2 = Get_d2psii_ddelta2(psi_i, delta, i);
        var d2psii_ddelta_dtau = Get_d2psii_ddelta_dtau(delta, tau, psi_i, i);
        var d3psii_ddelta2_dtau = Get_d3psii_ddelta2_dtau(delta, tau, psi_i, i);
        var dDELTAi_ddelta = Get_dDELTAi_ddelta(delta, theta_i, i);
        var d2DELTAi_ddelta2 = Get_d2DELTAi_ddelta2(theta_i, delta, dDELTAi_ddelta, i);
        var dDELTAibi_ddelta = Get_dDELTAibi_ddelta(dDELTAi_ddelta, DELTA_i, i);
        var dDELTAibi_dtau = Get_dDELTAibi_dtau(DELTA_i, theta_i, i);
        var d2DELTAibi_ddelta2 = Get_d2DELTAibi_ddelta2(d2DELTAi_ddelta2, dDELTAi_ddelta, DELTA_i, i);
        var d2DELTAibi_ddelta_dtau = Get_d2DELTAibi_ddelta_dtau(delta, dDELTAi_ddelta, DELTA_i, theta_i, i);
        var d2DELTAi_ddelta_dtau = Get_d2DELTAi_ddelta_dtau(delta, i);
        // const dDELTAi_dtau = Get_dDELTAibi_dtau(DELTA_i, theta_i, i);
        var d3DELTAi_ddelta2_dtau = Get_d3DELTAi_ddelta2_dtau(delta, d2DELTAi_ddelta_dtau, i);
        var d3DELTAibi_ddelta2_dtau = Get_d3DELTAibi_ddelta2_dtau(DELTA_i, dDELTAibi_dtau, dDELTAi_ddelta, d2DELTAi_ddelta_dtau, d3DELTAi_ddelta2_dtau, d2DELTAi_ddelta2, i);
        d3alphar_ddelta2_dtau += n[i] * (Math.pow(DELTA_i, b[i]) * (2 * d2psii_ddelta_dtau + delta * d3psii_ddelta2_dtau) + dDELTAibi_dtau * (2 * dpsii_ddelta + delta * d2psii_ddelta2) + 2 * d2DELTAibi_ddelta_dtau * (psi_i + delta * dpsii_ddelta) + 2 * dDELTAibi_ddelta * (dpsii_dtau + delta * d2psii_ddelta_dtau) + d3DELTAibi_ddelta2_dtau * delta * psi_i + d2DELTAibi_ddelta2 * delta * dpsii_dtau);
    }
    return d3alphar_ddelta2_dtau;
}
exports.Get_d3alphar_ddelta2_dtau = Get_d3alphar_ddelta2_dtau;
function Get_dpsii_ddelta(psi_i, delta, i) {
    var dpsii_ddelta = -2.0 * C[i] * (delta - 1.0) * psi_i;
    return dpsii_ddelta;
}
function Get_dpsii_dtau(tau, psi_i, i) {
    var dpsii_dtau = -2.0 * D[i] * (tau - 1) * psi_i;
    return dpsii_dtau;
}
function Get_d2psii_ddelta2(psi_i, delta, i) {
    var d2psii_ddelta2 = (2 * C[i] * Math.pow(delta - 1, 2) - 1) * 2 * C[i] * psi_i;
    return d2psii_ddelta2;
}
function Get_d2psii_ddelta_dtau(delta, tau, psi_i, i) {
    var d2psii_ddelta_dtau = 4 * C[i] * D[i] * (delta - 1) * (tau - 1) * psi_i;
    return d2psii_ddelta_dtau;
}
function Get_d3psii_ddelta2_dtau(delta, tau, psi_i, i) {
    var d3psii_ddelta2_dtau = -2.0 * (4.0 * C[i] * Math.pow(delta - 1, 2) - 2) * C[i] * D[i] * (tau - 1) * psi_i;
    return d3psii_ddelta2_dtau;
}
function Get_dDELTAi_ddelta(delta, theta_i, i) {
    var dDELTAi_ddelta = (delta - 1.0) *
        (A[i] * theta_i * (2.0 / beta[i]) * Math.pow(Math.pow(delta - 1.0, 2), 1.0 / (2.0 * beta[i]) - 1.0) +
            2.0 * B[i] * a[i] * Math.pow(Math.pow(delta - 1.0, 2), a[i] - 1.0));
    return dDELTAi_ddelta;
}
function Get_d2DELTAi_ddelta_dtau(delta, i) {
    var d2DELTAi_ddelta_dtau = -(delta - 1) * A[i] * (2 / beta[i]) * Math.pow(Math.pow(delta - 1, 2), 1 / (2 * beta[i]) - 1);
    return d2DELTAi_ddelta_dtau;
}
function Get_d2DELTAi_ddelta2(theta_i, delta, dDELTAi_ddelta, i) {
    var d2DELTAi_ddelta2 = (1.0 / (delta - 1.0)) * dDELTAi_ddelta +
        Math.pow(delta - 1.0, 2) *
            (Math.pow(A[i], 2) * 2.0 / (Math.pow(beta[i], 2)) *
                Math.pow((Math.pow((Math.pow((delta - 1.0), 2)), (1.0 / (2.0 * beta[i]) - 1.0))), 2) +
                A[i] * theta_i * (4.0 / beta[i]) * (1.0 / (2.0 * beta[i]) - 1.0) *
                    Math.pow((Math.pow((delta - 1.0), 2)), (1.0 / (2.0 * beta[i]) - 2.0)) +
                4.0 * B[i] * a[i] * (a[i] - 1.0) * Math.pow((Math.pow((delta - 1.0), 2)), (a[i] - 2.0)));
    return d2DELTAi_ddelta2;
}
function Get_d3DELTAi_ddelta2_dtau(delta, d2DELTAi_ddelta_dtau, i) {
    var d3DELTAi_ddelta2_dtau = (1.0 / (delta - 1)) * (d2DELTAi_ddelta_dtau) - Math.pow((delta - 1), 2) * A[i] * (4.0 / beta[i]) * (1.0 / (2 * beta[i]) - 1) * Math.pow((Math.pow((delta - 1), 2)), (1.0 / (2 * beta[i]) - 2));
    return d3DELTAi_ddelta2_dtau;
}
function Get_dDELTAibi_ddelta(dDELTAi_ddelta, DELTA_i, i) {
    var dDELTAibi_ddelta = b[i] * Math.pow(DELTA_i, b[i] - 1.0) * dDELTAi_ddelta;
    return dDELTAibi_ddelta;
}
function Get_dDELTAibi_dtau(DELTA_i, theta_i, i) {
    var dDELTAibi_dtau = -2.0 * theta_i * b[i] * Math.pow(DELTA_i, b[i] - 1);
    return dDELTAibi_dtau;
}
function Get_d2DELTAibi_ddelta2(d2DELTAi_ddelta2, dDELTAi_ddelta, DELTA_i, i) {
    var d2DELTAibi_ddelta2 = b[i] *
        (Math.pow(DELTA_i, b[i] - 1.0) * d2DELTAi_ddelta2 +
            (b[i] - 1.0) * Math.pow(DELTA_i, b[i] - 2.0) * Math.pow(dDELTAi_ddelta, 2));
    return d2DELTAibi_ddelta2;
}
function Get_d2DELTAibi_ddelta_dtau(delta, dDELTAi_ddelta, DELTA_i, theta_i, i) {
    var d2DELTAibi_ddelta_dtau = -A[i] * b[i] * (2.0 / beta[i]) * Math.pow(DELTA_i, b[i] - 1) * (delta - 1) * Math.pow((Math.pow(delta - 1, 2)), (1.0 / (2.0 * beta[i]) - 1)) - 2 * theta_i * b[i] * (b[i] - 1) * Math.pow(DELTA_i, b[i] - 2) * (dDELTAi_ddelta);
    return d2DELTAibi_ddelta_dtau;
}
function Get_d3DELTAibi_ddelta2_dtau(DELTA_i, dDELTAi_dtau, dDELTAi_ddelta, d2DELTAi_ddelta_dtau, d3DELTAi_ddelta2_dtau, d2DELTAi_ddelta2, i) {
    var dDELTAibiminus1_dtau = (b[i] - 1) * Math.pow(DELTA_i, b[i] - 2) * dDELTAi_dtau;
    var dDELTAibiminus2_dtau = (b[i] - 2) * Math.pow(DELTA_i, b[i] - 3) * dDELTAi_dtau;
    var ddDELTAi_ddelta2_dtau = 2 * d2DELTAi_ddelta_dtau * dDELTAi_ddelta;
    var d3DELTAibi_ddelta2_dtau = b[i] *
        ((dDELTAibiminus1_dtau * d2DELTAi_ddelta2 + Math.pow(DELTA_i, b[i] - 1) * d3DELTAi_ddelta2_dtau) +
            (b[i] - 1) * (dDELTAibiminus2_dtau * Math.pow(dDELTAi_ddelta, 2) + Math.pow(DELTA_i, b[i] - 2) * ddDELTAi_ddelta2_dtau));
    return d3DELTAibi_ddelta2_dtau;
}
